
import { defineComponent } from "vue";

export default defineComponent({
  name: "AppFilterArea",
  props: {
    optionsArea: {
      type: Array,
      required: true,
    },
    areaUpdate: {
      type: Array,
      require: true,
      default: null,
    },
  },
  emits: ["update:areaUpdate"],
  methods: {
    updateValue: function (e: Event) {
      const target = e.target as HTMLInputElement;
      const checked = target.checked;
      const val = target.value;
      const vals = [...this.areaUpdate];
      if (checked) {
        vals.push(val);
      } else {
        vals.splice(vals.indexOf(val), 1);
      }
      this.$emit("update:areaUpdate", vals);
    },
  },
  mounted() {
    [...(document.querySelectorAll(".-FilterArea dd input[type='checkbox']") as NodeListOf<HTMLInputElement>)].forEach((element) => {
      element.addEventListener("click", () => {
        CheckedArea();
      });
    });
    // エリア
    function CheckedArea() {
      let checkedText = "";
      [...(document.querySelectorAll(".-FilterArea dd input[type='checkbox']") as NodeListOf<HTMLInputElement>)].forEach((element) => {
        if (element.checked) {
          let areaText = element.nextElementSibling?.textContent;
          areaText += "、";
          checkedText += areaText;
        }
      });
      // 最後の1字を削る(句読点を削る)
      if (checkedText != "") {
        checkedText = checkedText.slice(0, -1);
      }
      const checkedAreaText = document.getElementById("js-checkedAreaText") as HTMLDivElement;
      if (checkedAreaText) {
        checkedAreaText.textContent = checkedText;
      }
    }
    // mounted終わり
  },
});
